import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../../shared/services/session.service';
import { Select2OptionData } from 'ng2-select2/ng2-select2.interface';
import { UserService } from '../../../shared/services/user.service';
import { User } from '../../../shared/models/user.model';
import { AuthorizationService } from '../../../shared/services/authorization.service';
import { Authorization } from '../../../shared/models/authorization.model';

import swal from 'sweetalert2';
import { VoucherAttachedService } from '../../../shared/services/voucher-attached.service';
import { forEach } from '@angular/router/src/utils/collection';
import { IconoUtility } from '../../../shared/utilities/icono.utility';
import { ApiConfig } from '../../../shared/services/config/api.config';
import { BeneficiaryService } from '../../../shared/services/beneficiary.service';
import { Beneficiary } from '../../../shared/models/beneficiary.model';
import { AuthService } from '../../../shared/services/auth.service';

declare var jQuery: any;

@Component({
  selector: 'office-auth-consult',
  templateUrl: './consult.component.html',
  styleUrls: ['./consult.component.css']
})
export class ConsultComponent implements OnInit {

  public beneficiarios: Select2OptionData[];

  public selectedBeneficiario: string;

  public autorizaciones: Authorization[];

  public mostrarAutorizaciones: boolean;

  contratoSeleccionado: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _sessionService: SessionService,
    private _userService: UserService,
    private _authorizationService: AuthorizationService,
    private _voucherAttached: VoucherAttachedService,
    private _apiConfig: ApiConfig,
    private _beneficiaryService: BeneficiaryService,
    private _authService: AuthService
  ) { }

  ngOnInit() {

    this.selectedBeneficiario = '';

    this.mostrarAutorizaciones = false;

    let _contractSelect = this._sessionService.getSelectContract();

    this.contratoSeleccionado = _contractSelect;

    this._beneficiaryService.getBeneficiariesContract(_contractSelect, this._sessionService.getCurrentUser().documentId,
      this._sessionService.getSelectDocumentTypeContracted()).subscribe(
      res => {

        let _res: User[];

        //Usuario menor de edad
        if (this._sessionService.getCurrentUser().age < 18) {
          let i: number;
          i = 0;
          for (let usuario of res) {
            if (usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId) {
              _res = this.toSelect2(Array<Beneficiary>(res[i]));
            }
            i++;
          }
        }
        else {
          let j: number;
          j = 0;
          var _array = [];

          for (let usuario of res) {
            _array.push(usuario);
            j++;
          }

          _res = this.toSelect2(_array);
        }
        /*else {
          
          if(this._sessionService.getCurrentUser().actualizacionMenu){
            //Usuario contratante
            let j : number;
            j = 0;
            var _array = [];
            
            for (let usuario of res){
                if(usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId
                  || usuario.edad < 18){
                  _array.push(usuario);
                }
                j++;
            }

            _res = this.toSelect2(_array);
          }
          else {
            //Usuario beneficiario mayor de edad
            let k : number;
            k = 0;
            var _array = [];
            
            for (let usuario of res){
                if(usuario.documentoIdentidad === this._sessionService.getCurrentUser().documentId
                  || usuario.edad < 18){
                  _array.push(usuario);
                }
                k++;
            }

            _res = this.toSelect2(_array);
          }
        }*/

        let _optionDefault = this.getOptionDefault();
        let _optionBeneficiarios = _res;
        let _options = _optionDefault.concat(_optionBeneficiarios);
        this.beneficiarios = _options;
      },
      err => {
        console.log(err);
      }
      )


  }

  toSelect2(source: Beneficiary[]): any[] {

    var _array = [];

    for (let s of source) {
      let _obj = {
        id: s.documentoIdentidad,
        text: s.documentoIdentidad + ' - ' + s.nombre
      };
      _array.push(_obj);
    }

    return _array;
  }

  irHomeAutorizaciones() {
    this.router.navigate(['/office/authorization/home']);
  }

  getOptionDefault(): any[] {
    return [{ id: '-1', text: 'Seleccione una opción...' }];
  }

  public changed(e: any): void {
    this.mostrarAutorizaciones = false;
    this.selectedBeneficiario = e.value;
    if (!(this.selectedBeneficiario == '-1' || this.selectedBeneficiario == '')) {

      this._authorizationService.getAuthorizations(this.contratoSeleccionado, this.selectedBeneficiario, this._sessionService.getCurrentUser().documentId).subscribe(
        res => {

          this.autorizaciones = res;

          if (this.autorizaciones.length > 0) {
            this.mostrarAutorizaciones = true;
          } else {
            swal({
              title: '<h4 style="color: #0054a5">Autorizaciones</h4>',
              html: `<p style="font-size:14px; margin: 10px">El beneficario <b>${e.data[0].text}</b> no registra autorizaciones</p>`,
              type: 'info',
              confirmButtonClass: 'btn btn-primary',
              buttonsStyling: false,
              focusConfirm: false
            });
          }
        },
        err => {
          console.log(err);
        }
      )

    }
  }

  mostrarAdjuntos(idTicket: string, tipo: number) {

    this._voucherAttached.getVoucherAttached(idTicket, tipo).subscribe(
      res => {
        let _vouchers = res;
        let _html = '';
        _html += `
          <table id="tableSoportesAdjuntos" class="table table-bordered primary" cellspacing="0" width="100%">
          <thead>
            <tr style="background-color: #0054a5; color: #ffff; text-align: center;">
              <th>Nombre archivo</th>
              <th>Fecha</th>
              <th>Descargar</th>
            </tr>
          </thead>
          <tbody>`;

        let _i = 1;

        for (let v of _vouchers) {
          _html += `
              <tr>
              <td><span id="filename${_i}">${v.fileName}</span><input id="file${_i}" type="hidden" value="${v.file}"/></td> 
              <td>${v.attachedDate}</td>
              <td><button id="btn${_i}" type="button" class="btn btn-xs btn-default btnDescarga" title="Descarga Adjunto"><img id="img${_i}" src="./assets/images/${IconoUtility.getNameIconoType(v.fileName)}.png" width="35"/></button></td>
              </tr>
            `;
          _i++;
        }

        _html += `</tbody>
          </table>
          <span id="message" style="font-type: 18px; font-weight: bold"></span>`;

        swal({
          width: 800,
          showCloseButton: true,
          padding: 20,
          title: '<h3 style="color: #0054a5">Archivos ' + (tipo === 1 ? 'Soporte' : 'Adjuntos') + ' - Autorización <b>' + idTicket + '</b></h3>',
          html: _html,
          confirmButtonClass: 'btn btn-info',
          confirmButtonText: 'Cerrar',
          allowOutsideClick: false,
          buttonsStyling: false,
          focusConfirm: false,
          onOpen: () => {
            jQuery("#message").text("");
            jQuery("#tableSoportesAdjuntos").addClass("tableSoportesAdjuntos");
            jQuery(".btnDescarga").click((result) => {             

              if (this._authService.isAuthenticateManagement()) {
                jQuery("#message").css("color", "red");
                jQuery("#message").text("Esta solicitud no puede ser procesada en el entorno de gestión");
              } else {

                var _id = '';
                _id = result.target.id;
                _id = _id.substring(3, _id.length);
                var _idfilename = 'filename' + _id;
                var _idfile = 'file' + _id;
                var _filename = jQuery("#" + _idfilename).text();
                var _file = jQuery("#" + _idfile).val();

                var xhr = new XMLHttpRequest();
                xhr.open('GET', this._apiConfig.url + '/vouchers/download/' + (tipo === 1 ? '5' : '6') + '?name=' + _file, true);
                xhr.setRequestHeader('Authorization', 'Bearer ' + this._sessionService.getToken());
                xhr.responseType = 'blob';

                xhr.onload = function (e) {
                  if (xhr.status == 200) {
                    var blob = new Blob([xhr.response], { type: 'application/octet-stream' });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = _filename;
                    link.click();

                    /*
                    swal({
                      width: 820,
                      title: 'Autorizaciones',
                      showCloseButton: true,
                      html: `
                      <object id="previewAutorizacion" data="${window.URL.createObjectURL(xhr.response)}" type="application/pdf" width="800" height="800">            
                      </object>       
                      `,
                      confirmButtonClass: 'btn btn-primary',
                      confirmButtonText: 'Cerrar',
                      allowOutsideClick: false,
                      buttonsStyling: false,
                      focusConfirm: false
                    });
                    */
                    jQuery("#message").css("color", "green");
                    jQuery("#message").text("Se ha descargado: " + _filename);
                  } else {
                    jQuery("#message").css("color", "red");
                    jQuery("#message").text("Ocurrio un error al descargar: " + _filename);
                  }
                };

                xhr.send();

              }
            });
          }
        });

      },
      err => {
        console.log(err);
      }
    );



  }

}



// WEBPACK FOOTER //
// /app/src/app/office/authorization/consult/consult.component.ts